import Swiper, { Autoplay } from "swiper";
import { MoveSlideToEnd } from "./MoveSlideToEnd";

class LocationSwiper {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError("Invalid element");
    }

    this.element = element;
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.element, {
      modules: [Autoplay],
      allowTouchMove: false,
      slidesPerView: "auto",
      spaceBetween: 120,
      speed: (14000 + (Math.floor(Math.random() * 5) * 500)),
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      on: {
        slideChangeTransitionEnd: (swiper) => {
          // trigger offset +1 because of the overlapping horizontal cards on mobile
          if (swiper.activeIndex === 2) {
            swiper.autoplay.stop();
            MoveSlideToEnd(swiper);
            swiper.autoplay.start();
          }
        }
      }
    });
  }
}

export default LocationSwiper;
